/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseStatusTime } from './CaseStatusTime';
import {
    CaseStatusTimeFromJSON,
    CaseStatusTimeFromJSONTyped,
    CaseStatusTimeToJSON,
    CaseStatusTimeToJSONTyped,
} from './CaseStatusTime';
import type { CaseStatusType } from './CaseStatusType';
import {
    CaseStatusTypeFromJSON,
    CaseStatusTypeFromJSONTyped,
    CaseStatusTypeToJSON,
    CaseStatusTypeToJSONTyped,
} from './CaseStatusType';

/**
 * 
 * @export
 * @interface CaseStatusDetail
 */
export interface CaseStatusDetail {
    /**
     * 
     * @type {CaseStatusType}
     * @memberof CaseStatusDetail
     */
    activeStep?: CaseStatusType;
    /**
     * 
     * @type {Array<CaseStatusTime>}
     * @memberof CaseStatusDetail
     */
    statuses?: Array<CaseStatusTime>;
    /**
     * 
     * @type {string}
     * @memberof CaseStatusDetail
     */
    initiatedBy?: string;
}



/**
 * Check if a given object implements the CaseStatusDetail interface.
 */
export function instanceOfCaseStatusDetail(value: object): value is CaseStatusDetail {
    return true;
}

export function CaseStatusDetailFromJSON(json: any): CaseStatusDetail {
    return CaseStatusDetailFromJSONTyped(json, false);
}

export function CaseStatusDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseStatusDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'activeStep': json['activeStep'] == null ? undefined : CaseStatusTypeFromJSON(json['activeStep']),
        'statuses': json['statuses'] == null ? undefined : ((json['statuses'] as Array<any>).map(CaseStatusTimeFromJSON)),
        'initiatedBy': json['initiatedBy'] == null ? undefined : json['initiatedBy'],
    };
}

export function CaseStatusDetailToJSON(json: any): CaseStatusDetail {
    return CaseStatusDetailToJSONTyped(json, false);
}

export function CaseStatusDetailToJSONTyped(value?: CaseStatusDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activeStep': CaseStatusTypeToJSON(value['activeStep']),
        'statuses': value['statuses'] == null ? undefined : ((value['statuses'] as Array<any>).map(CaseStatusTimeToJSON)),
        'initiatedBy': value['initiatedBy'],
    };
}

